import { render } from "./LogoFooterMock.vue?vue&type=template&id=f69fb8a0&scoped=true"
import script from "./LogoFooterMock.vue?vue&type=script&lang=js"
export * from "./LogoFooterMock.vue?vue&type=script&lang=js"

import "./LogoFooterMock.vue?vue&type=style&index=0&id=f69fb8a0&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f69fb8a0"]])

export default __exports__